// extracted by mini-css-extract-plugin
export default {"notification":"notification_notification__1Uobi","closeButton":"notification_closeButton__wsxYg","closeIcon":"notification_closeIcon__Gfgnw"};